module.exports = __webpack_public_path__ + "static/media/inbox-interactive-message.2732a146.svg";